document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;
  const header=document.querySelector('.site-header');
  const toggle=document.querySelector('.mobile-toggle');
  const menu=document.querySelector('.mobile-menu');
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const closeMenu=()=>{
    if(!menu||!toggle)return;
    menu.classList.remove('open');
    toggle.setAttribute('aria-expanded','false');
    toggle.textContent='Menu';
    body.classList.remove('menu-open');
  };
  const openMenu=()=>{
    if(!menu||!toggle)return;
    menu.classList.add('open');
    toggle.setAttribute('aria-expanded','true');
    toggle.textContent='Close';
    body.classList.add('menu-open');
  };
  if(toggle&&menu){
    toggle.addEventListener('click',(e)=>{
      e.stopPropagation();
      menu.classList.contains('open')?closeMenu():openMenu();
    });
    menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
    document.addEventListener('click',(e)=>{if(menu.classList.contains('open')&&!menu.contains(e.target)&&!toggle.contains(e.target))closeMenu();});
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape')closeMenu();});
    window.addEventListener('resize',()=>{if(window.innerWidth>980)closeMenu();},{passive:true});
  }

  const updateHeader=()=>header&&header.classList.toggle('is-scrolled',window.scrollY>10);
  updateHeader();
  window.addEventListener('scroll',updateHeader,{passive:true});

  if(!reduceMotion && 'IntersectionObserver' in window){
    body.classList.add('motion-ready');
    const selectors=[
      '.intro > *','.world-card','.story-copy > *','.activities-copy > *',
      '.page-hero > .wrap > *','.character-copy > *','.character-notes > div',
      '.series-gallery__feature','.series-gallery__tile','.section-kicker > *','.baby-series-card',
      '.activities-page > *','.about-split > *','.character-list > div','.product-card',
      '.books-cta .wrap > *','.footer-grid > *'
    ];
    const items=document.querySelectorAll(selectors.join(','));
    items.forEach(el=>el.classList.add('reveal-target'));
    const io=new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){entry.target.classList.add('revealed');io.unobserve(entry.target);}
      });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    items.forEach(el=>io.observe(el));
  }
});
